import React, { FunctionComponent } from 'react';
import { Grid, Typography, Box } from '@mui/material';
import i18next from 'i18next';

import { IProps } from './types';
import {
  ReviewContainer,
  SectionTitle,
  FieldLabel,
  FieldValue,
  FooterBox,
  StyledDivider,
} from './styles';
import './i18n';

const VALUE_MAPPING: Record<string, string> = {
  // Civil States
  SINGLE: 'Soltero/a',
  MARRIED: 'Casado/a',
  DIVORCED: 'Divorciado/a',
  WIDOWED: 'Viudo/a',
  // Cementeries
  OLD: 'Viejo',
  CANNING: 'Canning',
  ANNEX: 'Anexo',
};

const ProcedureReviewStep: FunctionComponent<IProps> = ({ sections }) => {
  const formatDisplayValue = (
    val: string | number | boolean | null | undefined,
  ): string | number => {
    if (typeof val === 'boolean') {
      return val ? i18next.t<string>('COMMON:YES') : i18next.t<string>('COMMON:NO');
    }

    if (typeof val === 'string' && VALUE_MAPPING[val.toUpperCase()]) {
      return VALUE_MAPPING[val.toUpperCase()];
    }

    return val ?? '';
  };

  return (
    <ReviewContainer>
      <Typography variant="h5" color="primary" gutterBottom sx={{ fontWeight: 'bold' }}>
        {i18next.t<string>('PROCEDURES:REVIEW_TITLE')}
      </Typography>
      <Typography variant="body2" sx={{ mb: 4, color: 'text.secondary' }}>
        {i18next.t<string>('PROCEDURES:REVIEW_SUBTITLE')}
      </Typography>

      {sections.map((section) => (
        <Box key={section.title} sx={{ mb: 4 }}>
          <SectionTitle>{section.title}</SectionTitle>
          <StyledDivider />

          <Grid container spacing={2}>
            {section.fields.map((field) =>
              field.value !== undefined && field.value !== null && field.value !== '' ? (
                <Grid item xs={12} sm={6} key={`${section.title}-${field.label}`}>
                  <FieldLabel>{field.label}</FieldLabel>
                  <FieldValue>{formatDisplayValue(field.value)}</FieldValue>
                </Grid>
              ) : null,
            )}
          </Grid>
        </Box>
      ))}

      <FooterBox>
        <Typography variant="body2" align="center" color="text.secondary">
          {i18next.t<string>('PROCEDURES:REVIEW_FOOTER')}
        </Typography>
      </FooterBox>
    </ReviewContainer>
  );
};

export default ProcedureReviewStep;
